var map = {
	"./X33-Mall_small.jpg": 917,
	"./all.svg": 918,
	"./apple-watch.png": 919,
	"./b-headphone.png": 920,
	"./coin.svg": 921,
	"./delete-btn.svg": 922,
	"./iphone-13.webp": 2355,
	"./iphone-pink.png": 923,
	"./love.svg": 924,
	"./mall-banner-cn.jpg": 925,
	"./mall-banner-id.jpg": 926,
	"./mall-banner-ms.jpg": 927,
	"./mall-banner-vn.webp": 2356,
	"./mall-banner.jpg": 928,
	"./mobile-bg.jpg": 929,
	"./price-high.svg": 930,
	"./price-low.svg": 931,
	"./shopping-cart.svg": 932,
	"./star.svg": 933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2354;